var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 1.49996C0.333984 1.03972 0.70708 0.666626 1.16732 0.666626H12.834C13.2942 0.666626 13.6673 1.03972 13.6673 1.49996C13.6673 1.9602 13.2942 2.33329 12.834 2.33329H1.16732C0.70708 2.33329 0.333984 1.9602 0.333984 1.49996ZM6.4114 4.24404C6.73683 3.9186 7.26447 3.9186 7.58991 4.24404L10.0899 6.74404C10.4153 7.06947 10.4153 7.59711 10.0899 7.92255C9.76447 8.24799 9.23683 8.24799 8.9114 7.92255L7.83398 6.84514V16.5C7.83398 16.9602 7.46089 17.3333 7.00065 17.3333C6.54041 17.3333 6.16732 16.9602 6.16732 16.5V6.84514L5.08991 7.92255C4.76447 8.24799 4.23683 8.24799 3.9114 7.92255C3.58596 7.59711 3.58596 7.06947 3.9114 6.74404L6.4114 4.24404Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b0bf64e55d09686981d6ac3bc9279f75.svg";
export { ForwardRef as ReactComponent };